var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__b",
    x1: 55.41,
    x2: 12.11,
    y1: 96.87,
    y2: 21.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e8e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34a853"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__c",
    x1: 42.7,
    x2: 86,
    y1: 100,
    y2: 25.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__a",
    x1: 6.7,
    x2: 93.29,
    y1: 31.25,
    y2: 31.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__a)",
    d: "M93.29 25a50 50 90 0 0-86.6 0l3 54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__b)",
    d: "M28.35 62.5 6.7 25A50 50 90 0 0 50 100l49-50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__c)",
    d: "M71.65 62.5 50 100a50 50 90 0 0 43.29-75H50z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 75a25 25 90 1 0 0-50 25 25 90 0 0 0 50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a73e8",
    d: "M50 69.8a19.8 19.8 90 1 0 0-39.6 19.8 19.8 90 0 0 0 39.6"
  })));
};
export default SvgChrome;